export const generateLocationModel = () => ({
  name: '',
  route: '',
});
